export default __webpack_public_path__ + "static/media/wp.4b3346da.svg";